import Icon from '@ant-design/icons';
import { EditOutlined } from '@ant-design/icons';
import '@ant-design/icons';
import { Button } from 'antd';
import { FC, useState } from 'react';
import ModalCalendar from '../Calendar';
import Wrap from './styles';

type Props = {
  title: string;
  icon: any;
};

const HeaderBilling: FC<Props> = ({ title, icon, children }) => {
  const [modalCalendarVisible, setModalCalendarVisible] = useState<boolean>(false);

  return (
    <Wrap>
      <div className="title">
        <div>
          <Icon component={icon} className="icon-billing" />
          <p className="extraLargeFont inline">{title}</p>
        </div>
        <div>
          <Button className="btn-deadline-bill" onClick={() => setModalCalendarVisible(true)}>
            <EditOutlined />
            支払い期日登録
          </Button>
          <ModalCalendar visible={modalCalendarVisible} eventActive={setModalCalendarVisible} />
        </div>
      </div>
      {children}
    </Wrap>
  );
};

export default HeaderBilling;
